import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { Entities } from '../Enums/Entities.enum';
import { SdObjType } from '../Enums/SdObjType.enum';

import { BusinessPartner } from './BusinessPartner.entity';
import { Project } from './Project.entity';

export class TravelAdditionalMealExpenses<T extends EMode = EMode.entity> {
  /** Alias: code */
  id?: number;
  /** Alias: reisekostenabrechnungCode */
  travelExpensesId?: number;
  /** Alias: dateTime */
  dateTime?: string;
  /** Alias: amount */
  amount?: number;
  /** Alias: hours */
  hours?: number;
  /** Alias: deductionBreakfast */
  deductionBreakfast?: boolean;
  /** Alias: deductionBreakfastAmount */
  deductionBreakfastAmount?: number;
  /** Alias: deductionDinner */
  deductionDinner?: boolean;
  /** Alias: deductionDinnerAmount */
  deductionDinnerAmount?: number;
  /** Alias: projectCode */
  projectId?: number;
  /** Alias: sdObjMemberCode */
  businessPartnerId?: number;
  /** Alias: sdObjType */
  businessPartnerType?: SdObjType;
  /** Alias: note */
  note?: string;
  /** Alias: deductionLunchAmount */
  deductionLunchAmount?: number;
  /** Alias: deductionLunch */
  deductionLunch?: boolean;
  /** Alias: project */
  project?: Project<T>;
  /** Alias: company */
  company?: BusinessPartner<T>;

  __typename?: string;
}

const fields: FieldDefinitions<TravelAdditionalMealExpenses> = {
  id: {
    alias: 'code',
  },
  travelExpensesId: {
    alias: 'reisekostenabrechnungCode',
  },
  dateTime: {
    alias: 'dateTime',
  },
  amount: {
    alias: 'amount',
  },
  hours: {
    alias: 'hours',
  },
  deductionBreakfast: {
    alias: 'deductionBreakfast',
  },
  deductionBreakfastAmount: {
    alias: 'deductionBreakfastAmount',
  },
  deductionDinner: {
    alias: 'deductionDinner',
  },
  deductionDinnerAmount: {
    alias: 'deductionDinnerAmount',
  },
  projectId: {
    alias: 'projectCode',
  },
  businessPartnerId: {
    alias: 'sdObjMemberCode',
  },
  businessPartnerType: {
    alias: 'sdObjType',
  },
  note: {
    alias: 'note',
  },
  deductionLunchAmount: {
    alias: 'deductionLunchAmount',
  },
  deductionLunch: {
    alias: 'deductionLunch',
  },
  project: {
    alias: 'project',
    entity: Entities.project,
  },
  company: {
    alias: 'company',
    entity: Entities.businessPartner,
  },
  __typename: {
    alias: '__typename',
  },
};

export const travelAdditionalMealExpensesEntityDefinition: EntitiyDefinition<TravelAdditionalMealExpenses> =
  {
    local: {},
    remote: {
      queryName: 'getTravelAdditionalMealExpenses',
      fragmentName: 'TravelAdditionalMealExpenses',
      withPaginationWrapper: true,
      params: [
        { name: 'querySize', type: 'Int' },
        { name: 'queryPage', type: 'Int' },
        { name: 'querySortOrder', type: 'SortOrderStyle' },
        { name: 'querySortBy', type: 'String' },
        { name: 'querySortByEx', type: '[SortByPair]' },
        { name: 'filter', type: 'String' },
      ],
    },
    fieldDefinitions: fields,
  };
